import { Facebook, Instagram, Linkedin, Heart, Shield } from "lucide-react";
import { SERVICE_AREA_LINKS } from '@shared/serviceAreaPages';

export default function Footer() {
  return (
    <footer className="bg-primary text-primary-foreground">
      {/* Main Footer */}
      <div className="container py-12 sm:py-16">
        <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-12">
          {/* Company Info */}
          <div className="space-y-4">
            <a href="/" aria-label="EZ Septic Pros home" className="inline-block hover:opacity-90 transition">
              <img
                src="/manus-storage/logo-footer-oval-192_04eef7de.webp"
                srcSet="/manus-storage/logo-footer-oval-128_7e194816.webp 128w, /manus-storage/logo-footer-oval-192_04eef7de.webp 192w, /manus-storage/logo-footer-oval-256_911d5f17.webp 256w"
                sizes="80px"
                alt="EZ Septic Pros Logo"
                width={192}
                height={192}
                loading="lazy"
                decoding="async"
                className="h-20 w-auto"
              />
            </a>
            <p className="text-primary-foreground/80 text-sm">
              Your trusted partner for professional septic system services across the Carolinas.
            </p>
            <div className="flex flex-wrap gap-2 pt-2">
              <div className="flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-lg font-bold text-sm shadow-md">
                <Heart className="w-5 h-5" />
                Family Owned
              </div>
              <div className="flex items-center gap-2 bg-accent text-accent-foreground px-4 py-2 rounded-lg font-bold text-sm shadow-md">
                <Shield className="w-5 h-5" />
                Veteran Owned
              </div>
            </div>
            <div className="flex gap-4">
              <a href="#" aria-label="Facebook" className="hover:text-accent transition">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" aria-label="Instagram" className="hover:text-accent transition">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="#" aria-label="LinkedIn" className="hover:text-accent transition">
                <Linkedin className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Residential Services */}
          <div>
            <h4 className="font-semibold mb-4">Residential Services</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>
                <a href="/residential" className="hover:text-accent transition">
                  Residential Overview
                </a>
              </li>
              <li>
                <a href="/services/septic-pumping" className="hover:text-accent transition">
                  Septic Pumping
                </a>
              </li>
              <li>
                <a href="/services/septic-installation" className="hover:text-accent transition">
                  Installation
                </a>
              </li>
              <li>
                <a href="/services/septic-inspection" className="hover:text-accent transition">
                  Inspection
                </a>
              </li>
              <li>
                <a href="/services/septic-repairs" className="hover:text-accent transition">
                  Repairs
                </a>
              </li>
              <li>
                <a href="/services/septic-system-design" className="hover:text-accent transition">
                  System Design
                </a>
              </li>
            </ul>
          </div>

          {/* Commercial Services */}
          <div>
            <h4 className="font-semibold mb-4">Commercial Services</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>
                <a href="/commercial" className="hover:text-accent transition">
                  Commercial Overview
                </a>
              </li>
              <li>
                <a href="/commercial#commercial-quote" className="hover:text-accent transition">
                  Request a Site Assessment
                </a>
              </li>
              <li>
                <a href="/services/septic-pumping" className="hover:text-accent transition">
                  Septic Pumping
                </a>
              </li>
              <li>
                <a href="/services/septic-inspection" className="hover:text-accent transition">
                  Inspection
                </a>
              </li>
              <li>
                <a href="/services/septic-repairs" className="hover:text-accent transition">
                  Repairs
                </a>
              </li>
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm text-primary-foreground/80">
              <li>
                <a href="/maintenance-plans" className="hover:text-accent transition">
                  EZ Maintenance Plans
                </a>
              </li>
              <li>
                <a href="/service-areas" className="hover:text-accent transition">
                  Service Areas
                </a>
              </li>
              <li>
                <a href="/faq" className="hover:text-accent transition">
                  FAQs
                </a>
              </li>
              <li>
                <a href="/about-us" className="hover:text-accent transition">
                  About Us
                </a>
              </li>
              <li>
                <a href="/careers" className="hover:text-accent transition">
                  Careers
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-primary-foreground/20 py-8">
          <div className="grid md:grid-cols-3 gap-8">
            {/* Contact Info */}
            <div className="text-sm text-primary-foreground/80">
              <p className="font-semibold text-primary-foreground mb-2">Contact Us</p>
              <p>
                <a href="tel:9809227867" className="hover:text-accent transition">
                  📞 980-922-PUMP
                </a>
              </p>
              <p className="text-accent font-semibold mt-1">Same-day emergency service available</p>
              <p>
                <a href="mailto:service@EZsepticPros.com" className="hover:text-accent transition">
                  ✉️ service@EZsepticPros.com
                </a>
              </p>
            </div>

            {/* Hours */}
            <div className="text-sm text-primary-foreground/80">
              <p className="font-semibold text-primary-foreground mb-2">Hours</p>
              <p>Monday - Friday: 7am - 6pm</p>
              <p>Saturday: 8am - 4pm</p>
              <p>Emergency: 24/7 Available</p>
            </div>

            {/* Service Area */}
            <div className="text-sm text-primary-foreground/80">
              <p className="font-semibold text-primary-foreground mb-2">Service Area</p>
              <div className="flex flex-wrap gap-x-3 gap-y-2">{SERVICE_AREA_LINKS.map(area => <a key={area.slug} href={area.href} className="hover:text-accent underline underline-offset-2">{area.county}</a>)}</div>
              <p>North Carolina</p>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Footer */}
      <div className="bg-primary/95 border-t border-primary-foreground/10">
        <div className="container py-6 flex flex-col md:flex-row justify-between items-center text-sm text-primary-foreground/70">
          <p>&copy; {new Date().getFullYear()} EZ Septic Pros. All rights reserved.</p>
          <div className="flex gap-6 mt-4 md:mt-0 items-center">
            <a href="/privacy" className="hover:text-accent transition">
              Privacy Policy
            </a>
            <a href="/terms" className="hover:text-accent transition">
              Terms & Conditions
            </a>
            <a href="/sitemap" className="hover:text-accent transition">
              Sitemap
            </a>
            <a href="/admin" className="bg-accent text-accent-foreground px-4 py-2 rounded-lg font-semibold hover:bg-accent/90 transition">
              Admin Login
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
